import { BondsPage } from "@/modules/bond/pages";
import { Layout } from "@/shared/layout";
import type { RouteObject } from "react-router-dom";

enum Paths {
  Bonds = "bonds",
}

export const bondRoutes: RouteObject = {
  path: Paths.Bonds,
  element: <Layout />,
  handle: {
    breadcrumb: () => ({ key: "breadcrumb.bonds" })
  },
  children: [
    { path: "", element: <BondsPage /> },
  ],
};
